<template>
  <b-row class="">
    <b-col cols="" class="card-box" :class="expanded ? 'h-61vh' : 'h-64vh'">
      <div class="body-box">
        <b-row>
          <b-col v-if="parentData" cols="12" md="12" class="mt-0">
            <PercentTable
              :data="parentData"
              titleClass="font-weight-bold ml-3"
              :showProgress="expanded"
            />
          </b-col>
          <b-col v-if="childData.length" cols="12" md="12" class="mt-0">
            <PercentTable
              v-for="(data, index) in childData"
              :key="index"
              :data="data"
              titleClass="ml-2"
              :showProgress="expanded"
            />
          </b-col>
        </b-row>
      </div>
      <slot name="user-box"></slot>
    </b-col>
  </b-row>
</template>

<script>
import PercentTable from "@/components/report/PercentTable.vue";
import { pathOr } from "ramda";
import { computed, toRefs } from "vue";

export default {
  components: { PercentTable },
  props: {
    item: {
      type: Object,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // generate props data
    const { item, expanded } = toRefs(props);

    // generate computed data
    const parentData = computed(() => pathOr(null, ["parent"], item.value));
    const childData = computed(() => {
      const output = [];
      const childTable = pathOr(null, ["child"], item.value);
      if (!childTable) return [];
      const childKeys = Object.keys(childTable);
      for (const key of childKeys) {
        const child = childTable[key];
        output.push({ ...child });
      }
      return output;
    });

    // return data to be used in template
    return { expanded, parentData, childData };
  },
};
</script>
<style lang="scss" scoped>
.card-box {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.h-64vh {
  height: 64vh;
}
.h-61vh {
  height: 61vh;
}
</style>
